var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#FFFFFF" } },
    [
      _c("div", { staticClass: "video_top" }, [
        _c("div", { staticClass: "vt" }, [
          _vm._m(0),
          _vm._v(" "),
          !_vm.public
            ? _c("div", { staticClass: "vt_nav" }, [
                _vm.practice.length == 0
                  ? _c(
                      "a",
                      {
                        staticClass: "vtn_wyks",
                        staticStyle: { background: "#C7C7C7" },
                        attrs: { href: "javascript:" }
                      },
                      [
                        _c("span"),
                        _vm._v(_vm._s(_vm.isCme ? "我要考试" : "我要练习"))
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "vtn_wyks",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.toPractice()
                          }
                        }
                      },
                      [
                        _c("span"),
                        _vm._v(_vm._s(_vm.isCme ? "我要考试" : "我要练习"))
                      ]
                    ),
                _vm._v(" "),
                _vm.handoutUrl == ""
                  ? _c(
                      "a",
                      {
                        staticClass: "vtn_jy",
                        staticStyle: { background: "#C7C7C7" },
                        attrs: { href: "javascript:" }
                      },
                      [_c("span"), _vm._v("讲　　义")]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "vtn_jy",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.openPDF()
                          }
                        }
                      },
                      [_c("span"), _vm._v("讲　　义")]
                    ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "vtn_xxmb",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        _vm.objectiveVisible = true
                        _vm.plyrInstances[0].pause()
                      }
                    }
                  },
                  [_c("span"), _vm._v("学习目标")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "vtn_lsjj",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        _vm.teachInfoVisible = true
                        _vm.plyrInstances[0].pause()
                      }
                    }
                  },
                  [_c("span"), _vm._v("老师简介")]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.videoLoading,
              expression: "videoLoading"
            }
          ],
          staticClass: "video_main",
          attrs: { "element-loading-text": "正在初始化播放器..." }
        },
        [
          _c("div", { staticClass: "vm" }, [
            _c("div", { staticClass: "vm_video" }, [
              _c("video", {
                ref: "video",
                staticStyle: { "border-radius": "4px" },
                attrs: { controls: "", crossorigin: "" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vm_list" }, [
              _c(
                "div",
                { staticClass: "vml_title", attrs: { title: _vm.courseName } },
                [_vm._v(_vm._s(_vm.courseName))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vml_main" }, [
                _c(
                  "ul",
                  _vm._l(_vm.courseVideoArr, function(item, index) {
                    return _c(
                      "li",
                      {
                        class: { vmlm_ing: _vm.defaultActive == index + 1 },
                        on: {
                          click: function($event) {
                            return _vm.handleSelect(index + 1)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _c("img", { attrs: { src: item.posterUrl } }),
                          _c("p", [
                            _vm._v(_vm._s(_vm.formatTime(item.videoTotalTime)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "javascript:" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.name) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vm_star" }, [
              _c("span", { staticClass: "vms_title" }, [_vm._v("我要评分：")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vms_pf" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isUserRate ? "我的评星" : "单击提交评星"
                              ) +
                              "：\n              "
                          ),
                          _c("el-rate", {
                            attrs: {
                              disabled: _vm.isUserRate,
                              texts: ["1分", "2分", "3分", "4分", "5分"],
                              "show-text": "",
                              "text-color": "#ff9900"
                            },
                            on: { change: _vm.rateChange },
                            model: {
                              value: _vm.userRate,
                              callback: function($$v) {
                                _vm.userRate = $$v
                              },
                              expression: "userRate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-rate", {
                        attrs: {
                          texts: ["1分", "2分", "3分", "4分", "5分"],
                          disabled: "",
                          "show-text": "",
                          "text-color": "#ff9900"
                        },
                        model: {
                          value: _vm.rateValue,
                          callback: function($$v) {
                            _vm.rateValue = $$v
                          },
                          expression: "rateValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$route.query.p != "true" &&
                        _vm.$route.query.p != true,
                      expression:
                        "$route.query.p!='true' && $route.query.p!=true "
                    }
                  ],
                  staticClass: "video_dabiao"
                },
                [
                  _vm._v(
                    "\n          达标要求：" +
                      _vm._s(_vm.trainingInfo.electiveRatio) +
                      "%      目前已完成 ：" +
                      _vm._s(_vm.percent) +
                      "%\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vm_qingxi" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "top" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n              标清:标准清晰度，适合网络条件好的情况，视频质量以及清晰度更高。\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              普清:普通清晰度，如果标清播放卡顿可以尝试切换此模式，视频质量相对低，但是播放会更流畅。\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-switch", {
                        staticStyle: { top: "10px", float: "right" },
                        attrs: {
                          "active-color": "#13ce66",
                          "active-text": "标清",
                          "allow-half": "",
                          "inactive-color": "#ff4949",
                          "inactive-text": "普清"
                        },
                        on: { change: _vm.playModeChange },
                        model: {
                          value: _vm.playModeValue,
                          callback: function($$v) {
                            _vm.playModeValue = $$v
                          },
                          expression: "playModeValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("comment", {
        staticClass: "video_comment",
        attrs: { typeId: "1_" + _vm.$route.query.cId }
      }),
      _vm._v(" "),
      _c("footer1"),
      _vm._v(" "),
      [
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.teachInfoVisible,
              title: "老师简介",
              width: "50%"
            },
            on: {
              "update:visible": function($event) {
                _vm.teachInfoVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "mt_main pl165 yh" }, [
              _c("div", { staticClass: "mtm_left" }, [
                _c("img", {
                  attrs: {
                    src: _vm.teachInfo.photo,
                    height: "185",
                    width: "150"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mtm_right" }, [
                _c("p", [_vm._v(_vm._s(_vm.teachInfo.nickName))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.teachInfo.about))])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.objectiveVisible,
              title: "学习目标",
              width: "50%"
            },
            on: {
              "update:visible": function($event) {
                _vm.objectiveVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "mt_main" }, [
              _c("p", [_vm._v("    " + _vm._s(_vm.objective))])
            ])
          ]
        ),
        _vm._v(" "),
        _c("loginLayer", {
          attrs: { visible: _vm.loginVisible },
          on: {
            "update:visible": function($event) {
              _vm.loginVisible = $event
            }
          }
        })
      ],
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.dialogVisible,
            size: "tiny",
            title: "练习"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.practiseData.stem))]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.practiseAns,
                callback: function($$v) {
                  _vm.practiseAns = $$v
                },
                expression: "practiseAns"
              }
            },
            _vm._l(_vm.practiseData.opts, function(item) {
              return _c(
                "el-radio",
                {
                  key: item.id,
                  staticStyle: {
                    display: "block",
                    "white-space": "nowrap",
                    "margin-left": "0px"
                  },
                  attrs: { label: item.opt }
                },
                [_vm._v(_vm._s(item.opt + " " + item.ctnt) + "\n      ")]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitAnswer } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vt_logo" }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", { attrs: { src: require("../assets/img/shiyan_logo2.png") } })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5609a61c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5609a61c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VideoPlayer.vue
// module id = null
// module chunks = 